export function addHoursToNow(intHours) {
  var numberOfMlSeconds = new Date().getTime()
  var addMlSeconds = intHours * 60 * 60 * 1000
  var newDateObj = new Date(numberOfMlSeconds + addMlSeconds)

  return newDateObj
}
